import { render, staticRenderFns } from "./UpdatePackingForm.vue?vue&type=template&id=739b74f2&"
import script from "./UpdatePackingForm.vue?vue&type=script&lang=js&"
export * from "./UpdatePackingForm.vue?vue&type=script&lang=js&"
import style0 from "./UpdatePackingForm.vue?vue&type=style&index=0&id=739b74f2&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports